/** Party Type refers to if this party is a Person or an Entity */
//use ePartyTypeData moving forward. BE uses uppercase enums
export enum ePartyType {
  person = 'person',
  entity = 'entity',
}

export const DisplayPartyType = {
  [ePartyType.entity]: 'Entity',
  [ePartyType.person]: 'Person',
};
